import request from "../Config/axios";

// -----------------------------------------------------------
export const GetByRserveAndMeal_Food_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Food_Reserve/GetByRserveAndMeal`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Food_Reserve_Api = async (reserveId) => {
    const { data } = await request.get(
        `/Food_Reserve/GetAll/?reserveId=` + reserveId,
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_Food_Reserve_Api = async (reserveId) => {
    const { data } = await request.get(
        `/Food_Reserve/GetAll_Active/?reserveId=` + reserveId,
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Food_Reserve_Api = async (id) => {
    const { data } = await request.delete(
        `/Food_Reserve/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Food_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Food_Reserve/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Food_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Food_Reserve/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Search_Food_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Food_Reserve/Search`,
        params
    );
    return data;
};
// -----------------------------------------------------------